import { FileText, AlertTriangle, Clock, ShieldCheck, Users } from "lucide-react";

const CARDS = [
  { key: "total_documents", label: "Documents", icon: FileText, color: "#2E5C50" },
  { key: "high_risk", label: "High Risk", icon: AlertTriangle, color: "#B54D40" },
  { key: "pending_review", label: "Pending Review", icon: Clock, color: "#C48231" },
  { key: "verified", label: "Verified", icon: ShieldCheck, color: "#34745C" },
  { key: "total_users", label: "Total Users", icon: Users, color: "#C07A60" },
];

export const StatCards = ({ stats }) => {
  if (!stats) return null;
  const cards = CARDS.filter((c) => stats[c.key] !== undefined);
  return (
    <div data-testid="stat-cards" className="grid grid-cols-2 md:grid-cols-4 lg:grid-cols-5 gap-4">
      {cards.map((c, i) => (
        <div
          key={c.key}
          data-testid={`stat-${c.key}`}
          className="fade-in-up bg-white border border-[#E8E6E1] rounded-lg p-5"
          style={{ animationDelay: `${i * 80}ms` }}
        >
          <div className="flex items-center justify-between">
            <span className="text-xs uppercase tracking-[0.15em] font-semibold text-[#57605A]">{c.label}</span>
            <c.icon className="w-4 h-4" strokeWidth={1.5} style={{ color: c.color }} />
          </div>
          <p className="mt-2 text-3xl font-heading font-bold" style={{ color: c.color }}>
            {stats[c.key]}
          </p>
        </div>
      ))}
    </div>
  );
};
